
/**
 * Utility to track page visit history in the application
 * This helps with returning users to their previous page after subscription
 */

// Track the current page path
export const trackCurrentPage = (path: string) => {
  // Don't track certain pages in history
  if (path === '/pricing' || 
      path === '/subscription-success' || 
      path === '/signup' || 
      path === '/login' || 
      path === '/manage-subscription') {
    return;
  }
  
  try {
    // Store current page as previous for later use
    sessionStorage.setItem('previousPagePath', path);
  } catch (error) {
    console.error('Error storing page history:', error);
  }
};

// Get the path to return to after a process
export const getReturnPath = (): string => {
  try {
    // Try to get the stored previous path
    const path = sessionStorage.getItem('previousPagePath');
    if (path) return path;
  } catch (error) {
    console.error('Error retrieving page history:', error);
  }
  
  // Default to home if no previous path
  return '/';
};

// Clear stored history
export const clearPageHistory = (): void => {
  try {
    sessionStorage.removeItem('previousPagePath');
  } catch (error) {
    console.error('Error clearing page history:', error);
  }
};
